export default __webpack_public_path__ + "static/media/162439417_108640001310522_2217681692066607400_n.3bcf1c77.jpg";